import User from 'types/User'
import { get } from 'lodash'

export const getFullName = (user: User): string => `${user.firstname} ${user.lastname}`

export const getRoleName = (user: User): string => get(user.role, 'name')

export const getDepartmentName = (user: User): string => get(user.department, 'name')
